import { render, staticRenderFns } from "./SupplierFactoryPerformanceTab.vue?vue&type=template&id=012fc652&scoped=true&"
import script from "./SupplierFactoryPerformanceTab.vue?vue&type=script&lang=js&"
export * from "./SupplierFactoryPerformanceTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012fc652",
  null
  
)

export default component.exports